(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 1281px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Login Dropdown Toggle
  document.addEventListener('DOMContentLoaded', function() {
    const loginTrigger = document.getElementById('login-dropdown-trigger');
    const loginDropdown = document.getElementById('login-dropdown');
    const passwordToggle = document.getElementById('password-toggle');
    const passwordInput = document.getElementById('login-password');
    
    if (loginTrigger && loginDropdown) {
      // Toggle dropdown on button click
      loginTrigger.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        const isExpanded = loginTrigger.getAttribute('aria-expanded') === 'true';
        
        if (isExpanded) {
          loginDropdown.style.display = 'none';
          loginTrigger.setAttribute('aria-expanded', 'false');
        } else {
          loginDropdown.style.display = 'block';
          loginTrigger.setAttribute('aria-expanded', 'true');
        }
      });
      
      // Close dropdown when clicking outside
      document.addEventListener('click', function(e) {
        if (!loginTrigger.contains(e.target) && !loginDropdown.contains(e.target)) {
          loginDropdown.style.display = 'none';
          loginTrigger.setAttribute('aria-expanded', 'false');
        }
      });
      
      // Prevent dropdown from closing when clicking inside
      loginDropdown.addEventListener('click', function(e) {
        e.stopPropagation();
      });
    }
    
    // Password visibility toggle
    if (passwordToggle && passwordInput) {
      passwordToggle.addEventListener('click', function() {
        const isPassword = passwordInput.type === 'password';
        const hiddenIcon = passwordToggle.querySelector('.login-dropdown__eye-icon--hidden');
        const visibleIcon = passwordToggle.querySelector('.login-dropdown__eye-icon--visible');
        
        if (isPassword) {
          passwordInput.type = 'text';
          if (hiddenIcon) hiddenIcon.style.display = 'none';
          if (visibleIcon) visibleIcon.style.display = 'block';
        } else {
          passwordInput.type = 'password';
          if (hiddenIcon) hiddenIcon.style.display = 'block';
          if (visibleIcon) visibleIcon.style.display = 'none';
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
